import OperationStatusResponse from "../models/misc/OperationStatusResponse";
import { TruckloadQuoteRequest } from "../models/quotes/TruckloadQuoteRequest";
import ServiceBase from "./ServiceBase";

class TruckloadQuoteService extends ServiceBase {
    submitQuote(request: TruckloadQuoteRequest): Promise<OperationStatusResponse> {
        return this.post<OperationStatusResponse>("/api/truckload/quote", request, null);
    }
}

export default new TruckloadQuoteService(); 